window.addEventListener('SITE_START', () => {
  const $section = document.querySelector('#homeWhoWeAre');
  if (!$section) return;

  document.querySelectorAll('#homeWhoWeAre .__bg .__gallery').forEach((gallery) => {
    gallery.querySelectorAll('.__img').forEach((img) => {
      const clonedImg = img.querySelector('span').cloneNode(true);
      img.appendChild(clonedImg);
      clonedImg.classList.add('__reflected');
    });
  });
  const sloganST = new SplitText('#homeWhoWeAre .__slogan', {
    type: 'lines, words, chars',
    linesClass: 'line',
    wordsClass: 'word',
    charsClass: 'char',
  });
  gsap.set(sloganST.chars, {
    opacity: 0.2,
  });
  // Text animation timeline
  const textTl = gsap.timeline({
    paused: true,
  });
  textTl.fromTo(
    sloganST.chars,
    {
      opacity: 0.2,
    },
    {
      opacity: 1,
      stagger: 0.1,
      duration: 0.2,
    },
    0
  );

  // Gallery animation timeline
  const galleryTl = gsap.timeline({
    paused: true,
  });

  const imageStates = [
    {
      from: { x: '0vw', z: '0vw', rotationY: -2 },
      to: { x: '-120vw', z: '30vw', rotationY: 12 },
      opacity: { from: 1, to: 0.3 },
    },
    {
      from: { x: '46vw', z: '-35vw', rotationY: -16 },
      to: { x: '-60vw', z: '21vw', rotationY: 6 },
      opacity: { from: 0.75, to: 1 },
    },
    {
      from: { x: '122vw', z: '-92vw', rotationY: -28 },
      to: { x: '0vw', z: '0vw', rotationY: -2 },
      opacity: { from: 0.4, to: 1 },
    },
  ];

  // Function to create gallery animation with translate3d optimization
  const createGalleryAnimation = (selector) => {
    const images = document.querySelectorAll(selector);

    images.forEach((img, index) => {
      const state = imageStates[index];
      if (!state) return;

      const fromTransform = {
        x: state.from.x,
        z: state.from.z,
        rotationY: state.from.rotationY,
      };

      const toTransform = {
        x: state.to.x,
        z: state.to.z,
        rotationY: state.to.rotationY,
        duration: 2,
        ease: 'none',
      };

      // Add transform animation
      galleryTl.fromTo(img, fromTransform, toTransform, 0);

      // Add opacity animation
      const imgElement = img.querySelector('img');
      galleryTl.fromTo(
        imgElement,
        { opacity: state.opacity.from },
        { opacity: state.opacity.to, duration: 1, ease: 'none' },
        0
      );
    });
  };

  // Create animations for both galleries
  createGalleryAnimation('#homeWhoWeAre .__left .__img');
  createGalleryAnimation('#homeWhoWeAre .__right .__img');

  ScrollTrigger.create({
    trigger: '#homeWhoWeAre',
    start: 'top top',
    end: 'bottom bottom',
    pin: '#homeWhoWeAre .__pin',
    pinSpacing: false,
    onUpdate: (self) => {
      const progress = self.progress;
      // Update text animation
      textTl.seek(textTl.duration() * progress);
      // Update gallery animation with smooth scrub
      galleryTl.seek(galleryTl.duration() * progress);
    },
  });

  ScrollTrigger.create({
    trigger: '#homeWhoWeAre',
    start: 'bottom bottom',
    end: 'bottom top',
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.set('#homeWhoWeAre .__pin-content', {
        yPercent: 30 * progress,
        opacity: 1 - progress,
      });
    },
  });
});
